import React from "react";
import { PawPrint, MapPinLine } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/opacity.css";
import { extractTextContent } from "../../shared/Utils/ExtractText";

const CampaignCard = ({ campaign, handleClick }) => {
  // Extract and prepare description text
  const getDescription = () => {
    const rawDescription =
      campaign.description ||
      campaign.animal_description ||
      campaign.campaign_description;
    if (!rawDescription) return "No description available";

    return extractTextContent(rawDescription);
  };

  return (
    <div
      className="relative bg-white rounded-2xl overflow-hidden max-w-[278px] w-full mx-auto cursor-pointer select-none flex flex-col"
      style={{
        height: "380px",
        boxShadow: "0px 4px 20px -4px rgba(0, 0, 0, 0.25)",
      }}
      onClick={() => handleClick(campaign)}
    >
      <div className="p-2">
        <div className="w-[263px] h-[207px] rounded-2xl overflow-hidden mx-auto">
          {campaign.campaign_images && campaign.campaign_images[0] ? (
            <LazyLoadImage
              src={campaign.campaign_images[0].image_url}
              alt={campaign.campaign_title}
              className="w-full h-full object-cover select-none pointer-events-none"
              effect="opacity"
              wrapperClassName="w-full h-full"
            />
          ) : (
            <img
              src="https://sap-app-prod.s3.us-west-2.amazonaws.com/web_images/placeholder-pet.jpg"
              alt={campaign.campaign_title}
              className="w-full h-full object-cover select-none pointer-events-none"
            />
          )}
        </div>
      </div>
      <div className="p-2 text-left flex-1 flex flex-col">
        <h2
          className="text-orange !font-montserrat text-lg font-bold mb-1"
          style={{
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",

            maxHeight: "3rem",
            lineHeight: "1.5rem",
          }}
        >
          {campaign.campaign_title}
        </h2>

        <div className="flex items-center mb-1">
          <PawPrint size={20} className="text-blue mr-2" />
          <Link
            to={`/nonprofit/${campaign.nonprofit_id}`}
            className="text-blue !text-xs !font-montserrat   "
            onClick={(e) => e.stopPropagation()}
          >
            {campaign.nonprofit_name}
          </Link>
        </div>

        <div className="flex items-center mb-3 ">
          <MapPinLine size={20} className="text-grey-featuredCampaign mr-2" />
          <span className="text-grey-featuredCampaign text-xs !font-montserrat">
            {campaign.nonprofit_address && campaign.nonprofit_address.city
              ? `${campaign.nonprofit_address.city}, ${campaign.nonprofit_address.state}`
              : campaign.nonprofit_location_state || ""}
          </span>
        </div>

        <p
          className="mb-4 !text-xs !font-montserrat"
          style={{
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
            minHeight: "2.2rem",
            maxHeight: "2.2rem",
            lineHeight: "1.2rem",
          }}
        >
          {getDescription()}
        </p>
        <div className="flex-grow"></div>
      </div>
    </div>
  );
};

export default CampaignCard;
